import { deliverySlice } from './slice';

export * from './bulkUpdateRouteStopsDeliveryInfo';
export * from './cancelProviderRoute';
export * from './createWarehouseDeliveryRoute';
export * from './deliveryStopsReorder';
export * from './dispatchProviderRoute';
export * from './getAllStopStatues';
export * from './getDriverLocationTrail';
export * from './getRoutes';
export * from './getScenarioComparison';
export * from './getWarehouses';
export * from './markCustomerPickupStopsComplete';
export * from './markRouteForProvider';
export * from './moveDeliveryStopsToCustomerPickup';
export * from './moveDeliveryStopsToRoute';
export * from './reopenRoute';
export * from './requoteProviderRoute';
export * from './setNightEnd';
export * from './setRouteDetails';
export * from './setSelectedWarehouseId';
export * from './unmarkRouteProvider';
export * from './state';

const { reducer, actions } = deliverySlice;

export const {
  confirmOrderDeliveryMethods,
  setSelectedRouteId,
  setSelectedCohortId,
  setRouteDetailsCardVisible,
  setSelectedStopsChangeRoute,
  setRouteListCardVisible,
  setStopDetailsCardVisible,
  setEditDeliveredQuantityCardVisible,
  setCohortListCardVisible,
  setCohortDetailsCardVisible,
  setSecondaryCardVisible,
  closeSecondaryCards,
  setRouteListEditRouteImportVisible,
  setScenarioComparisonVisible,
  setIsUpdateTruckMutationLoading,
  showPopover,
  hidePopover,
  showPrimaryCardContent,
  hidePrimaryCardContent,
  updateSecondaryStatusHasWarehouseNote,
  updateSecondaryStatusHasReminder,
  updateSecondaryStatusHasTasks,
  setOrderDetailsCardVisible,
  setActiveRouteListTab,
  setCohortViewVisible,
  updateRouteOriginInState,
  setEditLocationCohortSecondaryCardVisible,
  updateLocationCohortInState,
  setBulkEditRouteCardVisible,
  setMapIconFilters,
  setShowDriverLocationTrail,
  setManualRunTriggering,
} = actions;
export default reducer;
